import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slugify',
  standalone: true
})
export class SlugifyPipe implements PipeTransform {

  transform(value: string): string {
    return value
      .toLowerCase()
      .replace(/\s+/g, '-')        // spaces to dashes
      .replace(/\./g, '-')         // dots to dashes
      .replace(/[^a-z0-9\-]/g, '') // remove other characters
      .replace(/\-+/g, '-')        // collapse multiple dashes
      .replace(/^-+|-+$/g, '');    // trim leading/trailing dashes
  }

}
